import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { Reveal, SplitLines } from "@/components/ui-custom/Reveal";
import { COMPANY } from "@/lib/api";

export const CTABand = ({ title = ["Ready to stock", "something special?"], subtitle = "Open a trade account with Deliver. Tell us about your store and the ranges you're interested in, our team will be in touch to talk through pricing, delivery and account setup." }) => (
  <section className="bg-[var(--terracotta)] text-[var(--cream)] relative overflow-hidden grain" data-testid="cta-band">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end relative z-[2]">
      <div className="lg:col-span-8">
        <SplitLines as="h2" inView lines={title} className="font-display font-normal text-4xl sm:text-5xl lg:text-7xl leading-[1] " />
        <Reveal delay={0.2}><p className="mt-6 max-w-xl text-base md:text-lg font-light leading-relaxed text-[var(--cream)]/90">{subtitle}</p></Reveal>
      </div>
      <Reveal delay={0.3} className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-4 lg:items-end">
        <Link to="/become-a-stockist" className="btn-pill bg-[var(--ink)] text-[var(--cream)] hover:bg-[var(--cream)] hover:text-[var(--ink)]" data-testid="cta-band-stockist">Become a stockist <ArrowUpRight size={14} /></Link>
        <a href={COMPANY.phoneHref} className="btn-pill btn-outline-cream" data-testid="cta-band-phone"><Phone size={14} /> {COMPANY.phone}</a>
      </Reveal>
    </div>
  </section>
);
